export default (context) => {
    context.commit('setSelectAll', false);
}


// WEBPACK FOOTER //
// ./src/app/store/base/actions/clear-selection.js